// Libraries
import React from 'react'
import PropTypes from 'prop-types'

// Component
export const IconGoogle = ({ width, height, onClick }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 59 59"
      onClick={onClick}
      style={{ cursor: 'pointer' }}
    >
      <circle cx="29.5" cy="29.5" r="29.5" />
      <g transform="translate(17.205 15.656)">
        <g transform="translate(2.104)">
          <path
            className="a"
            fill="#fff"
            d="M15.769,0h.162A4.876,4.876,0,0,1,14.7,3.675a3.807,3.807,0,0,1-3.351,1.573A4.73,4.73,0,0,1,12.6,1.687,5.4,5.4,0,0,1,15.769,0Z"
            transform="translate(-0.903)"
          />
          <path
            className="a"
            fill="#fff"
            d="M22.486,18.162v.051A15.112,15.112,0,0,1,20.4,22.339c-.794,1.123-1.766,2.635-3.5,2.635-1.5,0-2.5-.992-4.035-1.019-1.627-.027-2.522.83-4.009,1.045H8.349a4.531,4.531,0,0,1-2.616-1.854A16.491,16.491,0,0,1,2.1,13.8v-1.15A7.589,7.589,0,0,1,5.3,6.47,5.286,5.286,0,0,1,8.93,5.606a8.933,8.933,0,0,1,1.777.524,4.809,4.809,0,0,0,1.776.548,4.178,4.178,0,0,0,1.246-.392,7.483,7.483,0,0,1,4.009-.732A5.542,5.542,0,0,1,21.826,8.06a5.433,5.433,0,0,0-2.664,5.351A5.512,5.512,0,0,0,22.486,18.162Z"
            transform="translate(-2.104 0)"
          />
        </g>
      </g>
    </svg>
  )
}

IconGoogle.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  onClick: PropTypes.func,
}

IconGoogle.defaultProps = {
  width: '45px',
  height: '45px',
  onClick: () => {},
}

export default IconGoogle
